var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n8n-tabs',{attrs:{"options":_vm.options,"value":_vm.value},on:{"input":_vm.onTabSelect,"tooltipClick":_vm.onTooltipClick}})}
var staticRenderFns = []

export { render, staticRenderFns }